import { Component, OnInit } from '@angular/core';
import { User, UserType, AppRole, Location, UserRegistrationModel } from '../models/user.model';
import { AnonymousSubscription } from 'rxjs/Subscription';
import { AuthUserService } from '../services/appInitialization/authUser.service';
import { LookupService } from '../services/lookups/lookup.service';
import { NgForm } from '@angular/forms';
import { RegistrationService } from '../services/registration.service';
import { Observable } from 'rxjs/Observable';
import { NgxPermissionsService } from 'ngx-permissions';
import { DISABLED } from '@angular/forms/src/model';

@Component({
  selector: 'app-registration',
  templateUrl: './registration.component.html',
  styleUrls: ['./registration.component.css']
})
export class RegistrationComponent implements OnInit {
  // User variables/data for registration
  currentUser: User;
  registerUserModel: UserRegistrationModel;
  userType: UserType;
  userRole: AppRole;
  // postEmployment: any;
  post: Location;
  division: Location;

  // lookup data
  userTypes: UserType[];
  // postEmployments: any[];
  appRoles: AppRole[];
  childLocations: Location[];
  showLaunchButtonClick: boolean = false;
  // Post User locations
  // regions: Location[];
  // countries: Location[];
  // posts: Location[];

  // HQ User locations
  // programAreas: Location[];
  //divisions: Location[];
 showRoleUserInformation: boolean=true;
  constructor(
    private authUser: AuthUserService,
    private lookupService: LookupService,
    private registrationService: RegistrationService,
    private permissionsService: NgxPermissionsService
  ) {}

  ngOnInit() {
    this.currentUser = this.authUser._user;
    this.registerUserModel = new UserRegistrationModel();
    this.registerUserModel.roleIds = new Array<number>();
    this.userType = new UserType();
  

    // User Types -- Post or HQ
    this.lookupService.getUserTypes().subscribe((data: UserType[]) => {
      this.userTypes = data;
      this.userTypes = this.userTypes.filter(type => type.typeName !== 'Unknown');
    });
   
    // Post User Types -- LES or FSO
    // this.postEmployments = [
    //   { id: 1, typeName: 'LES', roleIds: [3] },         // LES -> Author role ID = 3
    //   { id: 2, typeName: 'FSO', roleIds: [3, 4] }       // FSO -> Author, Approver roles ID = 3 & 4
    // ];
  }

  onChangeUserType(userType) {
    // get Root Locations for User Type
    this.lookupService.getRootLocations(this.userType.typeName).subscribe((data: Location[]) => {
      if (this.userType.typeName === 'PostUser') {
           this.disableButton = false;
        // PostUser->Regions
        // this.regions = data;
        //  this.programAreas = null;
      } else {
      this.disableButton = true;



       // alert ("Test");
        // HQ->ProgramAreas

        // this.programAreas = data;
        // this.regions = null;
      }
    });

    // clear child locations
    // this.countries = null;
    // this.posts = null;
    // this.divisions = null;

    // get App Roles for User Type
    this.lookupService.getAppRolesByUserTypeId(this.userType.id).subscribe((data: AppRole[]) => {
      this.appRoles = data;
      // console.log(this.appRoles);
    });
  }
   onChangeUserRole(userRole)   {
     // alert ('test');
    
    if (this.userRole.roleName=='Admin')
    {
      this.showLaunchButtonClick=true;
     //   alert (this.userRole.roleName);     
    }
    else
    {
      this.disableButton = false;
    }
  

    }
     OnUserRoleCancelButton()
     {
       this.showLaunchButtonClick = false;  
       this.disableButton = true;          
     }
      OnUserRoleOkButton()
     {
       this.showLaunchButtonClick = false;  
       this.disableButton = false;         
     }
  // onChangeRegion(region) {
  //   this.getChildLocations(region.id).then(
  //     (data) => {
  //       this.countries = data;
  //     }
  //   );
  // }

  // onChangeCountry(country) {
  //   this.getChildLocations(country.id).then(
  //     (data) => {
  //       this.posts = data;
  //     }
  //   );
  // }

  // onChangeProgramArea(programArea) {
  //   this.getChildLocations(programArea.id).then(
  //     (data) => {
  //       this.divisions = data;
  //     }
  //   );
  // }

  // getChildLocations(parentId: number): any {
  //   return new Promise((resolve) => {
  //     this.lookupService.getChildLocations(parentId).subscribe(
  //       (locations: Location[]) => {
  //         resolve(locations);
  //       }
  //     );
  //   });
  // }
  disableButton;
  registerPostUser() {
    this.registerUserModel.id = this.currentUser.id;
    this.registerUserModel.userTypeId = this.userType.id;
    // this.registerUserModel.locationId = this.post.id;
    // this.postEmployment.roleIds.forEach(roleId => {
    //   this.registerUserModel.roleIds.push(roleId);
    // });

    this.registerUser(this.registerUserModel);
    alert('Registered Successfully');
    this.disableButton = true;
    this.showRoleUserInformation = false;
  }

  registerHQUser() {
    this.registerUserModel.id = this.currentUser.id;
    this.registerUserModel.userTypeId = this.userType.id;
    // this.registerUserModel.locationId = this.division.id;
    this.registerUserModel.roleIds.push(this.userRole.id);

    this.registerUser(this.registerUserModel);
    alert('Registered Successfully');
    this.disableButton = true;
     this.showRoleUserInformation = false;
  }

  registerUser(registerUserModel: UserRegistrationModel) {
    this.registrationService.registerUser(registerUserModel).subscribe(resp => {
      if (resp.ok) {
        // successfully registered
        // remove 'Unknown' role, add selected UserType role
        // remove 'New', add 'Registered' permission
        this.permissionsService.removePermission('New');
        this.permissionsService.addPermission('Registered');

        // GetUser api call to update user var in AuthUser ??
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/registration/registration.component.ts